import {DashboardApiBase} from "@/api/paymentApi";


export class StatisticApi extends DashboardApiBase{

}

export default new StatisticApi();